import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding
  const permissions = store.getters && store.getters.getPermissions

  if (value && value instanceof Array) {
    if (value.length === 2) {
      const functionKey = value[1];
      const permissionArray = filterPermissions(permissions, functionKey);
      const hasPermission = functionKey === '' ? true : (permissionArray && permissionArray.length > 0);
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      console.log(`Need functionKey! Like v-permission="['PageFunctionKey', 'ButtonFunctionKey']"`);
      // throw new Error(`Need functionKey! Like v-permission="['PageFunctionKey', 'ButtonFunctionKey']"`);
      el.parentNode && el.parentNode.removeChild(el); 
    }
  } else {
    // ; // 默认开放权限
    el.parentNode && el.parentNode.removeChild(el); // 默认不开放权限
  }
}

// 筛选有权限的数组
function filterPermissions(permissions, functionKey) {
  const res = [];

  permissions.forEach(permission => {
    const tmp = { ...permission }
    if (tmp.children) {
      tmp.children = filterPermissions(tmp.children, functionKey);
    } else {
      if (tmp.functionKey && tmp.functionKey === functionKey) {
        res.push(tmp)
      } 
    }
    if (tmp.hasOwnProperty("children") && tmp.children && tmp.children.length > 0) {
      res.push(tmp)
    }
  })

  return res;
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  },
  filterPermissions,
}


// WEBPACK FOOTER //
// ./src/directive/permission/permission.js